import { Injectable } from "@angular/core";

import { isDecoratedWithQueryStringIgnore } from "../../decorators/query-string-ignore.decorator";

@Injectable({
    providedIn: "root"
})
export class QueryStringSerializationService {
    private static get PROPERTY_NAMES_DELIMITER(): string {
        return ".";
    }

    public serialize(data: any): string {
        return this.serializeInternal(data);
    }

    private serializeInternal(data: any, prefix: string = ""): string {
        if (!Object.keys(data).length) {
            return "";
        }

        const queryParams: Array<string> = [];

        for (const propertyName of Object.keys(data)) {
            if (!isDecoratedWithQueryStringIgnore(data, propertyName)) {
                const propertyPath = prefix ? `${prefix}${propertyName}` : propertyName;
                const propertyValue = data[propertyName];

                const queryParam = ((propertyValue !== null) && (typeof propertyValue === "object"))
                    ? this.serializeInternal(propertyValue, `${propertyPath}${QueryStringSerializationService.PROPERTY_NAMES_DELIMITER}`)
                    : `${encodeURIComponent(propertyPath)}=${encodeURIComponent(propertyValue || "")}`;

                queryParams.push(queryParam);
            }
        }

        return queryParams.filter(queryParam => queryParam.split("=")[1]).join("&");
    }

    public deserialize<TResult>(queryString: string): TResult {
        try {
            const resultObject = {};

            for (const queryParam of queryString.split("&")) {
                const pair = decodeURIComponent(queryParam).split("=");

                const propertyPath = pair[0].split(QueryStringSerializationService.PROPERTY_NAMES_DELIMITER);
                const propertyValue = pair[1];

                if (propertyValue) {
                    this.setPropertyValue(resultObject, propertyPath, propertyValue);
                }
            }

            return resultObject as TResult;
        } catch (error) {
            return {} as TResult;
        }
    }

    private setPropertyValue(resultObject: any, propertyPath: Array<string>, propertyValue: string): void {
        if (!propertyPath.length) {
            return;
        }

        const propertyAlias = propertyPath[0];
        const isPlainProperty = propertyPath.length === 1;

        if (isPlainProperty) {
            resultObject[propertyAlias] = propertyValue;
        } else {
            let nestedObject: any = null;

            if (resultObject.hasOwnProperty(propertyAlias)) {
                nestedObject = resultObject[propertyAlias];
            } else {
                const isArrayProperty = !isNaN(parseInt(propertyPath[1], 10));
                nestedObject = isArrayProperty ? [] : {};
                resultObject[propertyAlias] = nestedObject;
            }

            this.setPropertyValue(nestedObject, propertyPath.slice(1), propertyValue);
        }
    }
}
